/**
 * Helper functions for API modules
 * 
 * @created: MAZ - 2020-08-01
 * @updated: MAZ - 2020-12-22
 */

export function Exception(code, message) {
  this.message = message
  this.error = code
}

export function queryStr(params) {
  // Prepare Query string
  var s = ''
  params = params || {}
  for (var key in params) {
    s = (!s ? '?' : s + '&') + key + '=' + encodeURIComponent(params[key])
  }
  return (s);
}

export function parseErrorMessage(txt) {
  // Extracts the error message if it exists
  try {
    var err = JSON.parse(txt)
    return err.description || err.message || txt
  } catch (err) {
    return txt
  }
}

export function encodeFormData(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

// must import as 
// { Exception, queryStr, parseErrorMessage, encodeFormData }
 